import styled from 'styled-components';
import banner from 'assets/images/banner.png';

export const StyledItem = styled.div`
  background-image: url(${banner});
  background-size: cover;
  width: 100%;
  height: 160px;
  border-radius: 6px;
`;

export const StyledItemContent = styled.div`
  max-width: 414px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  flex: 1;
`;

export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTimeContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #c7e2ff;
  height: 40px;
  padding: 0 22px;
  border-radius: 2px;
  display: inline-flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  min-width: 250px;
  @media only screen and (max-width: 768px) {
    min-width: 100%;
  }
`;

export const DateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
